import { useContext, useEffect, useState } from "react";
import { TeamContext } from "../../../context";
import UpTokenCoin from "../../../assets/icons/upTokenCoin.svg";
import { IPlayer } from "../../../interfaces";
import { Phase } from "../../../util/enums";

const CelebrationMiniProfile = () => {
    const { game } = useContext(TeamContext);
    const [player, setPlayer] = useState<IPlayer | undefined>(undefined);

    useEffect(() => {
        if (game?.phase === Phase.SOLUTION_CHOSEN_REWARD) {
            setPlayer(game?.players.find((player: IPlayer) => { return player.email === game.gameInfo.currentPlayerEmail }));
        }
    
        if(game?.phase === Phase.RENDER_SPIN_WHEEL){
            setPlayer(game?.players.find((player: IPlayer) => { return player.email === game.gameInfo.currentSpinOwner }));
        }
    }, [game])


    if (!player) {
        return (<div> </div>)
    }

    return (
        <div className="celebration_mini_profile_wrapper celebration_mini_profile_animation">
            <div className="table_player_mini_profile_wrapper center_vertically" >

                <div className="table_player_mini_profile">
                    <div className={`table_player_mini_profile_personal_data text_color_${player.color}`}>
                        <div className="name">
                            {player?.nickname}
                        </div>
                        <div className="user_tokens">
                            <img
                                className="upper_token_coin_icon"
                                src={UpTokenCoin}
                                alt="edit pen"
                            />
                            <div className="upper_token_coin_text center_horizontally_and_vertically">
                                {game?.gameInfo.players[player?.email]?.upperTokens}
                            </div>
                        </div>
                    </div>
                    <div className="table_player_mini_profile_image_and_crown_wrapper">
                        <img
                            className={`table_player_mini_profile_image border_color_${player?.color}`}
                            src={`${process.env.REACT_APP_BACKEND_URL}images/${player?.email}.png`}
                            alt="Profile Icon"
                        />
                    </div>
                </div>

            </div>
        </div>
    )
}

export default CelebrationMiniProfile;